import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import Countries from 'Flow2/components/CustomCollections/CustomDataJson/countries.json';
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
export const countriesArr = [...Countries];
export const CONTENT_DATA = [
    { ID: "Produkte", DE: "Produkte", EN: "Products" },
    { ID: "Innovation", DE: "Innovation", EN: "Innovation" },
    { ID: "Motorsport", DE: "Motorsport", EN: "Motorsports" },
    { ID: "Unternehmen", DE: "Unternehmen", EN: "Company" },
    { ID: "Historie", DE: "Historie", EN: "History" },
    { ID: "Nachhaltigkeit", DE: "Nachhaltigkeit", EN: "Sustainability" },
    { ID: "Sport & Gesellschaft", DE: "Sport & Gesellschaft", EN: "Sports & Society" },
    { ID: "Szene & Passion", DE: "Szene & Passion", EN: "Scene & Passion" },
];

export const customObj = {
    format: {
        inputType: 'CustomDropDown',
        lgMsId: 'customdata.imgFormatLb',
        data: [
            { ID: "Hochformat", DE: "Hochformat", EN: "Portrait" },
            { ID: "Querformat", DE: "Querformat", EN: "Landscape" }
        ]
    },
    filetype: {
        inputType: 'CustomDropdownWithFadeBox',
        lgMsId: 'customdata.fileTypeLb',
        data: [
            { ID: "video", DE: "Video", EN: "Video" },
            { ID: "pictures", DE: "Foto", EN: "Photo" },
            { ID: "other", DE: "Dokument", EN: "Document" }
        ]
    }
}

//Rights
export const customrights = {
    inputType: 'CustomCheckBoxList',
    lgMsId: 'customdata.videoRightsLb',
    upload: { show: true, required: true, order: 9, tab: 'masterdata' },
    mandatory: true,
    name: CustomTypes.RIGHTS_FIELD,
    data: [{ id: CustomTypes.RIGHTS_NOTEMP, DE: 'keine zeitliche Einschränkung', EN: 'no temporally restriction' },
    { id: CustomTypes.RIGHTS_NOLOCAL, DE: 'keine lokale Einschränkung', EN: 'no local restriction' },
    { id: CustomTypes.RIGHTS_NOMEDIA, DE: 'keine mediale Einschränkung', EN: 'no medial restriction' }]
};


//Add To
const customproject = {
    inputType: 'CustomDropDownWithAddButton',
    lgMsId: 'customdata.projectsLb',
    name: 'project',
    data: []
};
const customroom = {
    inputType: 'CustomDropDownWithAddButton',
    lgMsId: 'customdata.roomsLb',
    name: 'room',
    data: []
};
const customdistribution = {
    inputType: 'CustomDropDownWithAddButton',
    lgMsId: 'customdata.distributionLb',
    name: 'distribution',
    data: []
};

const customeventroom = {
    inputType: 'CustomDropDownWithAddButton',
    lgMsId: 'customdata.eventroomsLb',
    name: 'eventroom',
    data: []
};

export const basicdataSubmenu = {
    inputType: 'CustomSubmenu',
    lgMsId: 'expertsearch.metadatDataLb',
    name: 'basicdata'
};
const customCreatedByProvider = {
    inputType: 'CustomOutsideCheckBox',
    lgMsId: 'customdata.createdByProvider',
    name: 'sendEmail',
};
export const sendEmail = [customCreatedByProvider];
export const uploadAddTo = [customproject, customroom];
export const uploadAddToForApps = [customproject, customroom, customdistribution];
export const uploadAddTo_pa = [customproject];
//EVENTROOM
export const uploadAddToAdvanced = [customproject, customroom, customeventroom];

/* ADD_FORM */
export const AddFormConfig = [
    {
        inputType: 'CustomAddDataBox',
        lgMsId: 'customdata.projectname',
        name: 'project',
        title: 'customdata.addProject',
        fMsgIdSubmit: 'customdata.createBtn'
    },
    {
        inputType: 'CustomAddDataBoxWithDropDown',
        lgMsId: 'customdata.roomname',
        name: 'room',
        title: 'customdata.addRoom',
        fMsgIdSubmit: 'customdata.createBtn',
        ddname: 'roomtype',
        ddlgMsId: 'customdata.roomtype',
        data: [
            { ID: "Download", DE: "Download", EN: "Download" },
            { ID: "Upload", DE: "Upload", EN: "Upload" },
            { ID: "Selection", DE: "Selection", EN: "Selection" }
        ]
    },
    {
        inputType: 'CustomAddDataBox',
        lgMsId: 'customdata.distributionname',
        name: 'distribution',
        title: 'customdata.addDistribution',
        fMsgIdSubmit: 'customdata.createBtn'
    },
    {
        inputType: 'CustomAddDataBox',
        lgMsId: 'customdata.eventroomname',
        name: 'eventroom',
        title: 'customdata.addEventroom',
        fMsgIdSubmit: 'customdata.createBtn'
    },
]

/*
* PROFILE
*/
const firstName = {
    inputType: 'ProfileInput',
    lgMsId: 'profile.firstNameLb',
    name: 'firstName',
    type: 'text'
}

const lastName = {
    inputType: 'ProfileInput',
    lgMsId: 'profile.lastNameLb',
    name: 'lastName',
    type: 'text'
}

const birthday = {
    inputType: 'ProfileDateBox'
}

const email = {
    inputType: 'ProfileInput',
    lgMsId: 'profile.emailLb',
    name: 'email',
    type: 'text'
}

const password = {
    inputType: 'ProfileInput',
    lgMsId: 'profile.passwordLb',
    name: 'password',
    type: 'password'
}

const confirmPassword = {
    inputType: 'ProfileInput',
    lgMsId: 'profile.confirmPasswordLb',
    name: 'confirmPassword',
    type: 'password'
}

const filesRelease = {
    inputType: 'NotificationGroup',
    header: '',
    subheader: 'profile.releaseLb',
    name: 'filesRelease',
}


export const profileUserBasic = () => {
    if (DataUtil.isPorscheArchiv()) return [firstName, lastName, birthday];
    return [firstName, lastName, birthday, email];
}
export const profileUserAccount = () => {
    return [password, confirmPassword];
}
export const profileUserNotification = [/*filesUpdate,*/ filesRelease]


